import Delegate from "//legramme.com/cdn/shop/t/76/assets/ftdomdelegate.min.js?v=167457923630348017651764174054";

export class RegisterSection extends HTMLElement {
  connectedCallback() {
    this._attachListeners();

    // Redirect after register
    var params = new URLSearchParams(window.location.search);
    var redirect_to = params.get('redirect_to');
    if(redirect_to != '') {
      sessionStorage.setItem('redirectAfterLogin', redirect_to);
    }

    let cleave = new Cleave('[name="customer[birthday]"]', {
      date: true,
      dateMin: '1900-01-01',
      dateMax: window.theme.today,
      datePattern: ['d', 'm', 'Y']
    });

    let that = this;

    CF.customerReady(function () {

      var $form = document.querySelector('#create-customer-form');

      $form.addEventListener('submit', function handleCustomFormSubmit(event) {
        event.preventDefault();



        document.querySelector('.account__form-button').classList.add('is-loading');

        // Create an object that we'll add key/value pairs to
        var formData = {};

        // Find any element inside the form that has a data-column-key attribute
        var $inputs = $form.querySelectorAll('[data-column-key]');

        // Loop through each of those elements to put together our formData object
        for (var i = 0; i < $inputs.length; i++) {
          var $input = $inputs[i];

          // Extract the key and value from each element
          var key = $input.getAttribute('data-column-key');
          var value = $input.value;

          // Ignore non-checked radio fields
          if ($input.type == 'radio' && !$input.checked) continue;

          // Use boolean values for checkboxes
          if ($input.type == 'checkbox') value = $input.checked;

          // Add the key/value pair to formData
          formData[key] = value;
        }

        // Finally, mutate the global customer data object
        CF.customer.set(formData);

        var customerSaveOptions = { // Always login and redirect to the account page after saving
          redirect: true,
          login: true,
          redirectUrl: window.theme.routes.account,
        };

        CF.customer.save(customerSaveOptions)
          .then(function (errorObj) {
            if (errorObj) {
              // You've got data problems. Look through errorObj and let the customer know.
            } else {
              // Customer has been created! They will automatically be logged in and redirected to /account
              console.log('customer has been created !')

              // send GTM event
              if (typeof window.pushDL !== 'undefined') {
                window.pushDL({ 'event': 'registration' });
              }

            }
            document.querySelector('.account__form-button').classList.remove('is-loading');
          })
          .catch(function (error) {
            alert('Failed to save customer! :(');
            console.error(error);
            document.querySelector('.account__form-button').classList.remove('is-loading');
          });
      });

    });

    let inputRedirect = document.querySelector('input[type="hidden"][name="checkout_url"]');

    // check for referrer to redirect on the good page
    if (sessionStorage.getItem('lg-redirection') !== null) {
      console.log('redirect', sessionStorage.getItem('lg-redirection'))
      if (inputRedirect) {
        inputRedirect.value = sessionStorage.getItem('lg-redirection');
      }
    }


  }

  _attachListeners() {
    new Delegate(this).on('change', '[data-action="newsletter-checkbox"]', this._toggleNewsletterCheckbox.bind(this));
  }

  _toggleNewsletterCheckbox(event, target) {
    target.value = target.checked;
  }

}
try {
  window.customElements.define('register-section', RegisterSection);
} catch (e) { }